import { render } from "./fzhsDetailAccount.vue?vue&type=template&id=271fd630&scoped=true"
import script from "./fzhsDetailAccount.vue?vue&type=script&lang=js"
export * from "./fzhsDetailAccount.vue?vue&type=script&lang=js"

import "./fzhsDetailAccount.vue?vue&type=style&index=0&id=271fd630&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271fd630"]])

export default __exports__